import { IfAbility } from '@efdigital/ll-addon-auth';
import { CoachingConfigsBrowse } from '@efdigital/ll-admin-v2/components/coaching/coaching-configs-browse.gts';
import type { ModelFrom } from '@efdigital/ll-admin-v2/lib/type-utils';
import type CoachingConfigsIndexRoute from '@efdigital/ll-admin-v2/routes/coaching/configs/index';
import type { TemplateOnlyComponent } from '@ember/component/template-only';
import { pageTitle } from 'ember-page-title';

interface CoachingConfigsIndexSignature {
  Args: {
    model: ModelFrom<CoachingConfigsIndexRoute>;
    controller: unknown;
  };
}

const CoachingConfigsIndexTemplate: TemplateOnlyComponent<CoachingConfigsIndexSignature> =
  <template>
    {{pageTitle "Coaching Configurations"}}
    <div class="container py-5">
      <IfAbility @ability="coaching-configs" @atLeast="viewer">
        <:if>
          <CoachingConfigsBrowse @coachingConfigs={{@model.coachingConfigs}} />
        </:if>
        <:else>
          <div class="alert alert-warning" role="alert">
            <h4 class="alert-heading">Access Denied</h4>
            <p class="mb-0">You do not have permission to view coaching
              configurations.</p>
          </div>
        </:else>
      </IfAbility>
    </div>
  </template>;

export default CoachingConfigsIndexTemplate;
